import script from "./PdfSelectSizeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfSelectSizeModal.vue?vue&type=script&setup=true&lang=js"

import "./PdfSelectSizeModal.vue?vue&type=style&index=0&id=0d57443d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d57443d"]])

export default __exports__